import { HeapEventType, trackEventInHeap } from 'utils/heapTracking'
import { useEffect, useMemo } from 'react'
import { useSecretIdentity } from 'components/SecretIdentity/Provider'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { Download } from 'blaze-ui/icons'
import { DownloadButtonProps } from 'components/SecretIdentity/Types'

export const DownloadButton = ({ size = 'md', ...buttonProps }: DownloadButtonProps) => {
  const { file } = useSecretIdentity()

  const link = useMemo(() => {
    if (!file) return ''
    return URL.createObjectURL(file)
  }, [file])

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(link)
    }
  }, [link])

  const handlePress = () => {
    if (!file) return

    trackEventInHeap(HeapEventType.Onboarding, { action: 'download-secret-identity' })
  }

  return (
    <ButtonLink
      size={size}
      download
      elementType="a"
      to={link}
      variant="secondary"
      frontIcon={Download}
      onPress={handlePress}
      isDisabled={!file}
      {...buttonProps}
    >
      Download
    </ButtonLink>
  )
}
